import {TagInformation} from './tag-information';
import {UnitRatingResponse} from './unit-rating-response';
import {PersonLogin} from '../person/person-login';
import {EntityKey} from '../entity/entity-key';
import {SfrEntry} from './sfr-entry';

export class ConfigurationSaveInformation {
  engineKey!: string;
  entityKey!: EntityKey;
  lineId!: string;
  ratingResponse!: UnitRatingResponse;
  taggingInformation!: TagInformation[];
  sfrEntries!: SfrEntry[];
  customerItemId!: string;
  poAmount!: number;
  prnField1!: string;
  initialUnitPrice!: number;
  updateUser!: PersonLogin;
}
